<template>
  <div
    class="relative pb-10 overflow-hidden transition-all duration-500"
    :class="{ 'max-h-full': active, 'max-h-60': !active }"
    ref="reviewWrap"
  >
    <article>
      <rating :rating="item.rating" />

      <p ref="reviewText" v-if="item.text" v-html="item.text" class="mb-6 mt-2 lg:text-xl font-regular text-dark"></p>

      <p v-if="item" class="text-grey text-base lg:text-lg">~ {{ item.name }}</p>
    </article>

    <a v-if="show" class="button border-0 rounded-none absolute left-0 bottom-0 z-10 w-full pr-0 pb-0 pt-8 text-center text-secondary cursor-pointer bg-gradient-to-t from-white via-white to-transparent" @click.prevent="active = !active">Read {{ active ? "Less" : "More" }}</a>
  </div>
</template>
<script>
import {defineComponent} from 'vue'
import Rating from './Rating.vue'

export default defineComponent({
    components: {
        Rating,
    },
    data() {
      return {
        maxCharsLimit: 200,
        show: true,
        active: false,
      }
    },
    props: {
      item: {},
    },
    created() {
        if( (this.item?.text?.length ?? 0) < this.maxCharsLimit ) {
            this.show = false
        }
    },
});
</script>
